import * as React from "react";
import {
  BODetailTopBar,
  BODetailTopBarItem,
} from "app/components/BOComponents/BODetailTopBar/BODetailTopBar";
import { groupAuth } from "app/utils/authGroups";

const CardTerminalsTopBar = () => {
  return (
    <BODetailTopBar>
      {groupAuth.hasAccessGroup(["Ops/Admin"]) ? (
        <BODetailTopBarItem
          text="Uploads"
          link={`/snapscan/ops/card_terminals`}
        />
      ) : null}
    </BODetailTopBar>
  );
};

export default CardTerminalsTopBar;
